export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './companies.service';
import { CompaniesService } from './companies.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [AuthenticationService, CompaniesService, UsersService];
